const views = {
    'aem-view@': {
        template: '<wow-aem-portal project="storelocator"></wow-aem-portal>'
    },
    'dynamic-content-bottom@': {
        template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
    }
};

const data = {
    analytics: 'bws:web:store locator',
    pageMetadata: [
        'PageMetadataService', function (pageMetadataService) {
            return pageMetadataService.getMetadata({ name: 'Stores' });
        }
    ]
};
module.exports = function ($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.rule(function (_$injector, $location) {
         const path = $location.path() || '';
         const old = '/stores';
         if (path.substring(0, old.length) === old) {
             $location.replace().path(path.replace(old, '/storelocator'));
         }
   });

    const provider = $stateProvider.state('shop.locator', {
        url: '/storelocator',
        views,
        data
    });
    provider.state('shop.locator.store', {
        url: '/:store',
        data
    });
    provider.state('shop.locator.store.intent', {
        url: '/:intent',
        data
    });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/locator.js
 **/